export const posts = [
  {
    title: "Asynchronous JavaScript",
    excerpt:
      "Beginner friendly guide about Asynchronous JavaScript, covering Callback functions, role of Web APIs, the Promises, callback queue etc.",
    url: "https://blog.azharzaman.com/post/asynchronous-javascript",
    banner: "https://miro.medium.com/max/700/1*UzjLmJVnqP35YOF4OldsVA.jpeg",
    publishedAt: "August 14, 2022",
    tags: ["javascript", "promises", "callbacks"],
  },
  {
    title: "SSR - SSG - ISR - CSR in Next.js - The Ultimate Guide",
    excerpt:
      "Are you a React lover? If you ask me, of course, I am a die-hard fan. In this article, will compare React and Next.js performance, CSR vs SSR, types or prerendering in Next.js, and something called ISR.",
    url: "https://blog.azharzaman.com/post/types-of-rendering-in-next-js-the-ultimate-guide",
    banner:
      "https://cdn.sanity.io/images/r4trdkw6/production/10ea30fdc27b57026c6bf956f4ce903ff7fc575c-1921x1082.png",
    publishedAt: "August 02, 2022",
    tags: ["nextjs", "ssr", "ssg", "isr", "csr"],
  },
  {
    title: "0 to 1 — How JavaScript works under the hood",
    excerpt:
      "In this article, we will learn a little history of JavaScript, How JavaScript works under the hood? What is the Runtime environment? What role does the JavaScript engine play in code execution? What the heck is Execution context? What is Scope, TDZ, and a lot more?",
    url: "https://blog.azharzaman.com/post/how-javascript-works-under-the-hood",
    banner: "https://miro.medium.com/max/700/1*UzjLmJVnqP35YOF4OldsVA.jpeg",
    publishedAt: "July 18, 2022",
    tags: ["javascript", "scope", "js-engine"],
  },

  {
    title: "0 to 1 — How JavaScript works under the hood (Part 2)",
    excerpt:
      "In this article, we will be focussing more on the remaining three major components of JavaScript runtime in the context of the browser which are Web APIs, Callback queue and The Eventloop. We will learn drawback of single-threaded nature.",
    url: "https://blog.azharzaman.com/post/how-javascript-works-under-the-hood-part-2",
    banner: "https://miro.medium.com/max/700/1*UzjLmJVnqP35YOF4OldsVA.jpeg",
    publishedAt: "July 22, 2022",
    tags: ["javascript", "callbacks", "eventloop"],
  },
];
